export const endpoints = {
  createImage: '/image',
  get: '/image',
  getFile: '/image/:imageId/file',
  delete: '/image/:imageId',
}
